import { host } from "utils/constants";

const defaultHost = host ?? "https://clamphook.com";

export const getUserProfile = defaultHost + "/auth/user_profile";

export const getPassword = defaultHost + "/auth/change_password";

export const getUserSubscriptions = defaultHost + "/eu/subscription/list/my";

export const getUsername = defaultHost + "/auth/change_username";

export const getEmail = defaultHost + "/auth/change_email";

export const getSelfDelete = defaultHost + "/auth/delete_self";

export const changeMobile = defaultHost + "/auth/change_mobile";

export const resendMobileOtp = defaultHost + "/auth/change_mobile/resend_otp";

export const verifyMobile = defaultHost + "/auth/verify_mobile";

export const getCBT = defaultHost + "/cbt/";

export const getCBTResume = defaultHost + "/cbt/resume";

export const getCBTUserInfo = defaultHost + "/cbt/info/";

export const submitCBT = defaultHost + "/cbt/submit";

export const updateCBT = defaultHost + "/cbt/update";

export const getScore = defaultHost + "/cbt/scores/";

export const getExamDetails = defaultHost + "/eu/exam/detail/";

export const generateCustomSet = defaultHost + "/eu/exam/generate";

export const getRegisteredExams = defaultHost + "/activities/registered_exams";

export const getRecommendedExams = defaultHost + "/eu/exam/recommended";

export const getPastExams = defaultHost + "/activities/cbt_history";

export const getSubjects = defaultHost + "/eu/content/subject";

export const getSection = defaultHost + "/eu/content/section";

export const getRanks = defaultHost + "/eu/exam/rankings/";

export const submitChapterSetQuestion =
  defaultHost + "/eu/content/question/chapter_set/submit";

export const submitSubtopicQuestion =
  defaultHost + "/eu/content/question/subtopic/submit";

export const submitSubtopicSetQuestion =
  defaultHost + "eu/content/question/subtopic_set/submit";

export const deleteSubtopicHistory =
  defaultHost + "/eu/content/history/chapter/";

export const deleteQuestionSetHistory =
  defaultHost + "/eu/content/history/chapter/";

export const markSubTopicAsComplete =
  defaultHost + "/eu/content/subtopic/mark_complete/";

export const getExamMetrics = defaultHost + "/eu/metrics/exam";

export const getSubtopicMetrics = defaultHost + "/eu/metrics/subtopic";

export const classRoomRegistration =
  defaultHost + "/eu/classroom/registration/";

export const generateBill = defaultHost + "/eu/classroom/payment/bill/";

export const getAllClass = defaultHost + "/eu/class/all_class";

export const getUpcomingClass = defaultHost + "/eu/class/all_upcoming_class";

export const submitUserImageForRegistration =
  defaultHost + "/eu/classroom/registrant/user_image/";

export const trialStatus = defaultHost + "/eu/classroom/trial_status/";

export const verifyEmail = defaultHost + "/auth/verify_email";

export const resendVerificationMail = defaultHost + "/auth/resend_email";

export const getZoomSignature = defaultHost + "/eu/zoom/get_zoom_details";

export const getPromotion = defaultHost + "/eu/promotion/?promotionType=";

export const getKarmaHistory = defaultHost + "/eu/karma/history/";

export const getNotes = defaultHost + "/eu/notes";

export const getChapterNotes = defaultHost + "/eu/notes/chapter/";

export const addSessionComment =
  defaultHost + "/eu/session/comments/add_session_comment/";

export const getSessionComment =
  defaultHost + "/eu/session/comments/all_session_comments/";

export const editNote = defaultHost + "eu/notes/";

export const getBoardExams = defaultHost + "eu/exam/all/";

export const getSubtopicSet =
  defaultHost + "/eu/content/questions/subtopic_set/";

// Classroom registrations for the current user
export const getMyClassroomRegistrations =
  defaultHost + "/eu/classroom/registrations/mine";

// All of the current user's trial requests, across every classroom
export const getMyTrialClaims = defaultHost + "/eu/classroom/trial_status/mine";

// Signed video URL (expires in 600s — fetch fresh on every play)
export const getVideoSignedUrl = defaultHost + "/eu/video/";

// Video activity & notes
export const allNotes = defaultHost + "/activities/all_notes";
export const recordVideoWatch = defaultHost + "/activities/video_watch";
export const videoComplete = defaultHost + "/activities/video_complete";
export const videoProgress = defaultHost + "/activities/video_progress";
export const videoNote = defaultHost + "/activities/video_note";
export const videoNotesByVideo = defaultHost + "/activities/video_notes/";
export const subjectOverview = defaultHost + "/activities/subject_overview";

export const notices = defaultHost + "/eu/notice/";

export const noticeDetail = (noticeId: string) => defaultHost + "/eu/notice/" + noticeId;

// Device session management
export const myDevices = defaultHost + "/auth/my_devices";
export const myDeviceById = (sessionId: string) =>
  `${defaultHost}/auth/my_devices/${sessionId}`;

// Book delivery
export const bookDeliveryEligibility =
  defaultHost + "/eu/book-delivery/eligibility/";
export const bookDeliveryBranches =
  defaultHost + "/eu/book-delivery/branches";
export const bookDeliveryBranchesGrouped =
  defaultHost + "/eu/book-delivery/branches/grouped";
export const bookDeliveryShippingRate =
  defaultHost + "/eu/book-delivery/shipping-rate";
export const bookDeliveryRegion =
  defaultHost + "/eu/book-delivery/region/";
export const bookDeliveryStatus =
  defaultHost + "/eu/book-delivery/status/";

export const getPersonalizedClassrooms =
  defaultHost + "/eu/classroom/personalized/all_classes";
